<script lang="ts">
  interface Props {
    list?: string[];
  }

  let { list = [] }: Props = $props();
</script>

<div class="screenshot-wrap">
  {#each list || [] as screenshot}
    {#if screenshot.indexOf('data:') === 0 || screenshot.indexOf('blob:') === 0}
      <img class="screenshot" src={screenshot} alt="Screenshot" />
    {:else}
      <img class="screenshot" src={`data:image/png;base64,${screenshot}`} alt="Screenshot" />
    {/if}
  {/each}
</div>

<style>
  .screenshot-wrap {
    position: relative;
    height: 100%;
  }

  .screenshot-wrap .screenshot,
  .screenshot-wrap .screenshot img {
    width: 100%;
  }
</style>
